import React, { createContext, useContext, useState, useCallback } from 'react'

interface ContentRefreshContextType {
  lastContentUpdate: number
  triggerContentRefresh: () => void
}

const ContentRefreshContext = createContext<ContentRefreshContextType | undefined>(undefined)

export function ContentRefreshProvider({ children }: { children: React.ReactNode }) {
  const [lastContentUpdate, setLastContentUpdate] = useState(Date.now())

  const triggerContentRefresh = useCallback(() => {
    console.log('[ContentRefresh] Triggering content refresh at', new Date().toLocaleTimeString())
    setLastContentUpdate(Date.now())
  }, [])

  return (
    <ContentRefreshContext.Provider value={{ lastContentUpdate, triggerContentRefresh }}>
      {children}
    </ContentRefreshContext.Provider>
  )
}

export function useContentRefresh() {
  const context = useContext(ContentRefreshContext)
  if (context === undefined) {
    throw new Error('useContentRefresh must be used within a ContentRefreshProvider')
  }
  return context
}
